import { Avatar, Icon, IconType } from "@dexibit/core";
import { faTrianglePersonDigging } from "@fortawesome/pro-solid-svg-icons";

import { LogoMark } from "../../assets/logoMark";
import { LogoText } from "../../assets/logoText";

import raviChandra from "./ravi-chandra.png";
import {
  Brand,
  Contact,
  ContactEmail,
  ContactName,
  ContactText,
  HomeNote,
  IconWrap,
  Lede,
  Panel,
  Root,
  Support,
  SupportLabel,
  TextGroup,
  Title,
} from "./styles";

const WEBSITE_URL = "https://www.accesso.ai/";
const CONTACT_NAME = "Ravi Chandra";
const CONTACT_EMAIL = "ravi.chandra@accesso.com";

export const MaintenancePage = () => {
  return (
    <Root>
      <Brand>
        <LogoMark />
        <LogoText />
      </Brand>

      <Panel>
        <IconWrap>
          <Icon type={IconType.fa} icon={faTrianglePersonDigging} />
        </IconWrap>

        <TextGroup>
          <Title>We&rsquo;ll be right back</Title>
          <Lede>
            accesso Intelligence is offline for planned maintenance while we make some
            improvements. Your data is safe and everything will be just as you left it
            once we&rsquo;re back.
          </Lede>
        </TextGroup>

        <HomeNote>
          In the meantime, our home page is still available at{" "}
          <a href={WEBSITE_URL} target="_blank" rel="noopener noreferrer">
            accesso.ai
          </a>
          .
        </HomeNote>

        <Support>
          <SupportLabel>Need a hand?</SupportLabel>
          <Contact href={`mailto:${CONTACT_EMAIL}`}>
            <Avatar alt={CONTACT_NAME} imageSrc={raviChandra} initials="RC" size={44} />
            <ContactText>
              <ContactName>{CONTACT_NAME}</ContactName>
              <ContactEmail>{CONTACT_EMAIL}</ContactEmail>
            </ContactText>
          </Contact>
        </Support>
      </Panel>
    </Root>
  );
};

export default MaintenancePage;
